"use client";

import { useStore } from "@nanostores/react";
import FullPageSpinner from "common/components/FullPageSpinner";
import LeftRail from "common/components/Nav/LeftRail";
import OpteraAppBar from "common/components/Nav/OpteraAppBar";
import SnackbarReader from "common/components/SnackbarReader";
import { railExpandedStore } from "common/stores/NavigationRailStore";
import { user as appUser } from "common/stores/UserStore";
import { useEffect, useState } from "react";

export default function ClientAppLayout({
	children,
}: {
	children: React.ReactNode;
}) {
	const $user = useStore(appUser);
	const $expanded = useStore(railExpandedStore);
	const [hydrated, setHydrated] = useState(false);

	useEffect(() => {
		setHydrated(true);
	}, []);

	if (
		!hydrated ||
		typeof window == "undefined" ||
		!$user ||
		!$user.username ||
		$user.username == "loading"
	) {
		return <FullPageSpinner />;
	}

	return (
		<div
			id="opteraLayout-wrapper"
			className={hydrated && $expanded ? "nav-wide" : ""}
		>
			<OpteraAppBar items={[]} />
			<LeftRail />
			<main>
				<div id="dynoExpander">{children}</div>
			</main>
			<SnackbarReader />
		</div>
	);
}
